import script from "./InputDateCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./InputDateCalendar.vue?vue&type=script&setup=true&lang=js"

import "./InputDateCalendar.vue?vue&type=style&index=0&id=76a52b6f&lang=scss"

const __exports__ = script;

export default __exports__